var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "max-w-3xl mx-auto invoice-step-details" }, [
    _c(
      "div",
      { staticClass: "border border-gray-200 rounded-lg p-4 font-outfit mb-6" },
      [
        _c("InvoiceDetails", {
          attrs: { details: _vm.invoiceInfo },
          on: { edit: _vm.onEditClick },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "border border-gray-200 rounded-lg p-4 font-outfit mb-6" },
      [
        _c(
          "section",
          { staticClass: "invoice-details" },
          [
            _c(
              "header",
              { staticClass: "flex justify-between items-center mb-4" },
              [
                _c("h2", { staticClass: "text-xl font-semibold m-0" }, [
                  _vm._v("Total Hours"),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "text-blue text-base hover:text-black",
                    on: {
                      click: function ($event) {
                        return _vm.onEditClick(1)
                      },
                    },
                  },
                  [_vm._v(" Edit ")]
                ),
              ]
            ),
            _c("InvoiceTable", {
              attrs: { headers: _vm.headers, data: _vm.invoiceData },
            }),
          ],
          1
        ),
      ]
    ),
    _c("div", { staticClass: "invoice-form-button" }, [
      _c(
        "div",
        { staticClass: "invoice-form-button-wrap" },
        [
          _c("UiButton", {
            attrs: {
              disabled: _vm.isLoading,
              type: "button",
              buttonText: "Submit",
              buttonClasses:
                "px-2 pr-3.5 pl-3.5 customHeight40 invoice-submit-button",
              variant: "black",
            },
            on: { click: _vm.submitInvoice },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }